import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { SettingsIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { useSelector } from 'react-redux';
import { SETTINGS_SECTION } from 'features/settings_modal/constants';
import { getSettingsNavigationLinkProps, useSettingsNavigation } from 'features/settings_modal/use_settings_navigation';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
const ADMIN_NOTETAKER_SETTINGS_PATH = '/app/admin/notetaker/access';
const bannerWrapperCss = "b1ik5heg";
const styledBannerContainerCss = "sznareg";
const AdminNotetakerSettingsLink = ({
  children
}) => {
  const {
    hrefForSettingsSection,
    navigateToSettingsSection
  } = useSettingsNavigation();
  const notetakerSettingsTarget = hrefForSettingsSection(SETTINGS_SECTION.adminNotetaker, ADMIN_NOTETAKER_SETTINGS_PATH);
  const notetakerSettingsLinkProps = getSettingsNavigationLinkProps({
    target: notetakerSettingsTarget,
    navigate: () => navigateToSettingsSection(SETTINGS_SECTION.adminNotetaker, {
      legacyPath: ADMIN_NOTETAKER_SETTINGS_PATH
    })
  });
  return <Link {...notetakerSettingsLinkProps}>
      {children}
    </Link>;
};
export const AdminDisabledNotetakerBanner = ({
  adminDisabledNotetaker
}) => {
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  if (!adminDisabledNotetaker) return null;
  return <div className={bannerWrapperCss}>
      <div className={styledBannerContainerCss}>
        <ContextualBanner icon={SettingsIcon} variant="standard">
          {isAdminOrOwner ? HtmlParser(I18n.t('publisher.personal_settings.meeting_recaps.admin_disabled_notetaker_banner_for_admins'), {
          AdminNotetakerSettingsLink
        }) : I18n.t('publisher.personal_settings.meeting_recaps.admin_disabled_notetaker_banner')}
        </ContextualBanner>
      </div>
    </div>;
};

require("./admin_disabled_notetaker_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./admin_disabled_notetaker_banner.js");